import {UseQueryOptions} from "@tanstack/react-query/src/types";
import {useQuery} from "@tanstack/react-query";
import {fromOrdinal2map, listValoriTabellaAzienda, TabellaAziendaParams} from "@commons/services/presenze_api/tabelleAzienda.api";
import {CentroDiCostoRecord} from "@commons/mapping/CentroDiCostoRecord";
import {useMemo} from "react";
import {ProfiloAccessoAndPolicies} from "@commons/mapping/LoginResultRecord";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectAzienda, selectProfiloAccessoAndPolicies} from "@commons/core.slice";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {TabellaWFRecord} from "@commons/mapping/TabellaWFRecord";

export function useValoriTabellaAzienda(params: TabellaAziendaParams | null, opt?: UseQueryOptions) {
    return useQuery<CentroDiCostoRecord[] | null>({
        queryKey: ["valoriTabellaAzienda", params],
        queryFn: () => {
            return listValoriTabellaAzienda(params!)
        },
        enabled: !!params,//===skip
    });
}

export function useValoriPolicies(tabellaWF: TabellaWFRecord | undefined) {
    const userProfile: ProfiloAccessoAndPolicies | null = useAppSelector(selectProfiloAccessoAndPolicies); // Profilo User corrente
    const aziendaRecord: AziendaRecord | null = useAppSelector(selectAzienda);// Azienda corrente
    const {data: cdic, isLoading} = useValoriTabellaAzienda(aziendaRecord && tabellaWF && (tabellaWF.idTipoTabella || tabellaWF.idTipoTabella === 0) ? {
        idAziendaTabelle: aziendaRecord.idAziendaCDIC,
        idTabella: fromOrdinal2map(tabellaWF.idTipoTabella).url
    } : null); // Carico tabella raggruppamento
    const elencoValoriTabella = useMemo(() => {
        if (cdic && userProfile && userProfile.tabelle)
            return cdic.filter(item => CentroDiCostoRecord.isValid(item))
                .filter(({id}) => {
                    return userProfile.tabelle.find(itemTabelle => itemTabelle.codValore === id);
                })
        else if (cdic)
            return cdic.filter(item => CentroDiCostoRecord.isValid(item));
        else
            return [];
    }, [userProfile, cdic])
    return {elencoValoriTabella, isLoading, elencoValoriCompleto: cdic};
}